/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Nda_Pending_SinceInputs */



/**
* | output |
* | --- |
* | "Signature requested on {date} — the member can sign from their profile page." |
*
* @param {Nda_Pending_SinceInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_pending_since = /** @type {((inputs: Nda_Pending_SinceInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Pending_SinceInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Signature demandée le ${i?.date} — le membre peut signer depuis sa page de profil.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Firma solicitada el ${i?.date} — el miembro puede firmar desde su página de perfil.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Assinatura solicitada em ${i?.date} — o membro pode assinar na página de perfil.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Firma richiesta il ${i?.date} — il membro può firmare dalla sua pagina profilo.`)
	return /** @type {LocalizedString} */ (`Signature requested on ${i?.date} — the member can sign from their profile page.`)
});